export const Flags = {
    LoginAndSecurityEnabled: "isLoginAndSecurityEnabled",
    SecretsEnabled: "isSecretsEnabled",
    OrgLocalRunnerSettingsVisible: "orgLocalRunnerSettingsVisible",
};
